import { InsightsPointsRankingTopWidget } from '@/features/insights/PointsRanking/TopWidget'
import { Card } from '@/shared/ui/Card'
import { GameIcon } from '@/shared/ui/GameIcon'
import { PageHeader, Screen } from '@/shared/ui/Layout'
import { ProgressBar } from '@/shared/ui/ProgressBar'

import { RankingPodium } from './components/RankingPodium'
import { useRankingData } from './hooks/useRankingData'

const RankingSkeleton = () => (
  <div className="flex flex-col gap-3" aria-busy>
    <div className="h-[200px] animate-pulse rounded-2xl bg-gray-200/80" />
    <div className="h-[300px] animate-pulse rounded-2xl bg-gray-200/80" />
  </div>
)

export const DigitalProductRanking = () => {
  const {
    top3,
    rest,
    myRanking,
    meIsListed,
    isOnTopTier,
    topTierGap,
    topTierPercent,
    isEmpty,
    isLoading
  } = useRankingData()

  return (
    <Screen>
      <Screen.Context>
        <PageHeader title="Ranking" />

        {!isLoading && !isEmpty && (
          <Card className="shadow-sm">
            <Card.Body className="flex flex-col gap-3 px-4 pb-3 pt-4">
              <RankingPodium top3={top3} />

              {myRanking && (
                <div className="flex items-center gap-3 rounded-[0.625rem] bg-[color-mix(in_srgb,var(--color-brand)_8%,white)] px-3 py-2.5">
                  <div className="flex shrink-0 flex-col items-center">
                    <span className="text-caps font-bold uppercase tracking-wide text-gray-500">
                      Sua posição
                    </span>
                    <span className="text-xl font-bold leading-tight text-[var(--color-brand)]">
                      #{myRanking.rank}
                    </span>
                    <span className="flex items-center gap-1 text-2xs font-semibold text-gray-600">
                      <GameIcon name="star" size={10} />
                      {myRanking.points} XP
                    </span>
                  </div>

                  {topTierGap != null && topTierPercent != null && (
                    <div className="flex min-w-0 flex-1 flex-col gap-1.5">
                      <span className="text-xs font-semibold text-gray-700">
                        Faltam {topTierGap} XP para entrar no Top 10
                      </span>
                      <ProgressBar
                        value={topTierPercent}
                        variant="primary"
                        size="sm"
                      />
                    </div>
                  )}

                  {isOnTopTier && (
                    <span className="flex-1 text-xs font-semibold text-gray-700">
                      Você está no Top 10! Continue pontuando para subir no
                      pódio.
                    </span>
                  )}
                </div>
              )}
            </Card.Body>
          </Card>
        )}
      </Screen.Context>

      <Screen.Content className="pt-2">
        {isLoading && <RankingSkeleton />}

        {!isLoading && isEmpty && (
          <Card className="shadow-sm">
            <Card.Body className="px-4 py-6 text-center">
              <p className="m-0 text-sm font-bold text-gray-900">
                O ranking será liberado em breve
              </p>
              <p className="m-0 mt-1 text-xs text-gray-600">
                Complete jornadas e missões para começar a acumular experiência.
              </p>
            </Card.Body>
          </Card>
        )}

        {!isLoading && rest.length > 0 && (
          <div className="mb-8 flex flex-col gap-2 rounded-2xl bg-gray-100 p-2">
            {rest.map(entry => (
              <InsightsPointsRankingTopWidget
                key={entry.id}
                {...entry}
                size="sm"
              />
            ))}
            {!meIsListed && myRanking && (
              <InsightsPointsRankingTopWidget {...myRanking} me size="sm" />
            )}
          </div>
        )}
      </Screen.Content>
    </Screen>
  )
}

DigitalProductRanking.pageTitle = 'Ranking'
